<template>
  <div>
    <el-form-item label="类型">
      <!-- <el-switch v-model="value.multiple"></el-switch> -->
      <el-radio-group v-model="value.inputType"  class="radio-group-city">
        <el-radio label="city"><span class="name-text">省市</span></el-radio>
        <el-radio label="area"><span class="name-text">省市区</span></el-radio>
        <el-radio label="detail"><span class="name-text">省市区-街道</span></el-radio>
      </el-radio-group>
    </el-form-item>
  </div>

</template>

<script>
export default {
  name: "AreaPicker",
  components: {},
  props:{
    value:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

.radio-group-city /deep/ .el-radio{
  display: block;
  line-height: 28px;
}
</style>